import * as React from "react";
import { Wrapper } from "./Wrapper";

export interface IControl {
  useFullscreen?: boolean;
  isMinimalUI?: boolean;
  autoplayRunning?: boolean;
  children?: any;
  isLeftHandMode?: boolean;
  isTickerHidden?: boolean;
}

export const Controls = ({ children, ...props }: IControl) => (
  <Wrapper {...props}>{children}</Wrapper>
);
